





















































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Button,
  Card,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  Option,
  Select
} from 'element-ui';
import Callout from '@/components/Callout.vue';
import FileTag from '@/components/FileTag.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// options
import { responsiblePartyOptions } from '@/constants/responsiblePartyOptions.ts';
import { visibilityOptions } from '@/constants/visibilityOptions.ts';

// rules
import rules from '@/rules/rules';

// services
import { signedUploadService } from '@/services/SignedUploadService';

// gql
import assignAttachmentMutation from '@/graphql/mutations/attachment/Assign.gql';
import createAttachmentMutation from '@/graphql/mutations/attachment/Create.gql';
import createFilelessAttachmentMutation from '@/graphql/mutations/attachment/CreateFileless.gql';
import deleteAttachmentMutation from '@/graphql/mutations/attachment/Delete.gql';
import fetchAttachments from '@/graphql/queries/attachment/List.gql';
import updateAttachmentMutation from '@/graphql/mutations/attachment/Update.gql';

// types
import { AttachmentFields } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    attachments: {
      query: fetchAttachments,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update(data) {
        return data?.attachments || [];
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    }
  },
  components: {
    Callout,
    FileTag,
    UtcDatePicker,
    'el-button': Button,
    'el-card': Card,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class Files extends Vue {
  attachments: AttachmentFields[] = [];
  editAttachmentId = null;
  uploadAttachmentId = '';
  isPrivate = true;
  isEditing = false;
  isUploading = false;
  renameInput = {
    fileName: null
  };

  tempRequests = [];

  requestInput = {
    dueDate: null,
    memo: null,
    responsibleParty: 'shippio',
    tag: null
  };

  savedFilesWithAttachment = [];
  savedRequestedFiles = [];

  $refs: {
    requestForm: HTMLFormElement;
    assignFile: HTMLFormElement;
    fileForm: HTMLFormElement;
    fileInput: HTMLFormElement;
    renameInput: HTMLFormElement[];
  };

  readonly responsiblePartyOptions = responsiblePartyOptions();
  readonly visibilityOptions = visibilityOptions();
  readonly rules = rules;

  isOverdue(request) {
    return new Date() > new Date(request.dueDate) && request.dueDate !== null;
  }

  get filesWithAttachment() {
    const filesWith = this.attachments.filter(
      (attachment) => attachment.url !== null
    );
    // prevent sorting if we are editing
    if (!this.isEditing) {
      this.savedFilesWithAttachment = this.sortFiles(filesWith);
    }
    return this.savedFilesWithAttachment;
  }

  get requestedFiles() {
    const requestedFiles = this.attachments.filter(
      (attachment) => attachment.url === null
    );
    // prevent sorting if we are editing
    if (!this.isEditing) {
      const sorted = this.sortFiles(requestedFiles);
      this.savedRequestedFiles = [...sorted, ...this.tempRequests];
    }
    return this.savedRequestedFiles;
  }

  // sort by tag then by date if tag are equal
  sortFiles(attachments) {
    const prefixedTags = [
      'an',
      'bl',
      'customs_permit',
      'insurance',
      'co',
      'invoice',
      'packing_list'
    ];

    return attachments.sort((a, b) => {
      // No tag: Upload date, Newer uploads comes on top
      if (!a.tag && !b.tag) {
        return (
          new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime()
        );
      }
      // No tag: comes after With tag files
      if (!a.tag) return 1;
      if (!b.tag) return -1;

      // Custom tags: Tag name, Alphabetical order
      if (
        !prefixedTags.includes(a.tag) &&
        a.tag.toLowerCase() > b.tag.toLowerCase()
      ) {
        return 1;
      }
      if (
        !prefixedTags.includes(b.tag) &&
        a.tag.toLowerCase() < b.tag.toLowerCase()
      ) {
        return -1;
      }
      // Custom tag: Upload date, Newer uploads comes on top
      if (!prefixedTags.includes(a.tag) && !prefixedTags.includes(b.tag)) {
        return (
          new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime()
        );
      }
      // Custom tags: comes after prefixed tag files
      if (!prefixedTags.includes(a.tag)) return 1;
      if (!prefixedTags.includes(b.tag)) return -1;

      // With tag: Tag name, Alphabetical order
      if (a.tag > b.tag) return 1;
      if (a.tag < b.tag) return -1;
      // With tag: Upload date, Newer uploads comes on top
      if (new Date(a.uploadedAt).getTime() > new Date(b.uploadedAt).getTime()) {
        return -1;
      }
      if (new Date(a.uploadedAt).getTime() < new Date(b.uploadedAt).getTime()) {
        return 1;
      }
      return 0;
    });
  }

  updateRequest(request) {
    this.isEditing = true;
    this.editAttachmentId = request.id;
    this.requestInput.tag = request.tag;
    this.requestInput.dueDate = request.dueDate;
    this.requestInput.responsibleParty = request.responsibleParty;
    this.requestInput.memo = request.memo;
  }

  uploadRequested(id) {
    this.uploadAttachmentId = id;
    this.$refs.assignFile.click();
  }

  addRequest() {
    if (!this.tempRequests.length) {
      this.tempRequests.push({ ...this.requestInput, id: null });
    }
  }

  cancelEdit(id) {
    if (!id) {
      this.tempRequests = [];
      this.requestInput = {
        tag: null,
        dueDate: null,
        memo: null,
        responsibleParty: 'shippio'
      };
    } else {
      this.editAttachmentId = '';
    }
    this.isEditing = false;
  }

  handleSave(request) {
    this.$refs.requestForm.validate(async(valid: boolean) => {
      if (!valid) {
        return;
      }

      if (request.id) {
        this.updateAttachment(request);
      } else {
        this.createRequest(request);
      }
    });
  }

  async createRequest(request) {
    this.isUploading = true;

    try {
      const response = await this.$apollo.mutate({
        mutation: createFilelessAttachmentMutation,
        variables: {
          shipmentId: this.$route.params.id,
          filelessCreationArgs: {
            tag: request.tag,
            dueDate: request.dueDate || null,
            responsibleParty: request.responsibleParty || 'shippio',
            memo: request.memo || null
          }
        }
      });

      if (response) {
        this.isEditing = false;
        this.tempRequests = [];
        this.$apollo.queries.attachments.refetch();
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.isUploading = false;
    }
  }

  async uploadFile(event: Event) {
    const files = this.$refs.fileInput.files || [];
    this.isUploading = true;

    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];

      try {
        const response = await signedUploadService.startClientUpload(file);

        if (response) {
          try {
            const upload = await this.$apollo.mutate({
              mutation: createAttachmentMutation,
              variables: {
                attachmentsArgs: {
                  shipmentId: this.$route.params.id,
                  attachments: [
                    { key: response.key, isPrivate: this.isPrivate }
                  ]
                }
              }
            });
          } catch (error) {
            this.$store.dispatch('Alert/addAlert', {
              type: 'error',
              message: this.$t('error.push'),
              time: 2000
            });
          }
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      }
    }
    this.isUploading = false;
    this.$apollo.queries.attachments.refetch();
  }

  async assignFile(event: Event, id: string) {
    const files = this.$refs.assignFile.files || [];
    this.isUploading = true;

    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];

      try {
        const response = await signedUploadService.startClientUpload(file);

        if (response) {
          try {
            const upload = await this.$apollo.mutate({
              mutation: assignAttachmentMutation,
              variables: {
                attachmentId: id,
                s3Key: response.key
              }
            });
            this.uploadAttachmentId = '';
          } catch (error) {
            this.$store.dispatch('Alert/addAlert', {
              type: 'error',
              message: this.$t('error.push'),
              time: 2000
            });
          }
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      }
    }
    this.isUploading = false;
    this.$apollo.queries.attachments.refetch();
  }

  async deleteAttachment(id: string | null) {
    if (id) {
      try {
        const response = await this.$apollo.mutate({
          mutation: deleteAttachmentMutation,
          variables: {
            id
          }
        });

        if (response) {
          this.$apollo.queries.attachments.refetch();
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.deleted'),
            time: 2000
          });
        }
      } catch (error) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      }
    }
  }

  editAttachment(attachment: AttachmentFields) {
    this.isEditing = true;
    this.renameInput.fileName = attachment.name;
    this.editAttachmentId = attachment.id;
    this.$nextTick(() => {
      this.$refs.renameInput[0].focus();
    });
  }

  handleUpload(visibility: 'private' | 'public') {
    this.isPrivate = visibility === 'private';
    this.openFile();
  }

  openFile() {
    this.$refs.fileInput.click();
  }

  handleUpdate(attachment: AttachmentFields) {
    this.$refs.fileForm.validate(async(valid: boolean) => {
      if (!valid) {
        return;
      }
      this.updateAttachment(attachment);
    });
  }

  async updateAttachment(attachment: AttachmentFields) {
    try {
      const response = await this.$apollo.mutate({
        mutation: updateAttachmentMutation,
        variables: {
          attachmentId: attachment.id,
          attachmentArgs: {
            name:
              this.editAttachmentId !== null
                ? this.renameInput.fileName
                : attachment.name,
            private: attachment.private,
            tag: attachment.tag || '',
            dueDate: attachment.dueDate || null,
            responsibleParty: attachment.responsibleParty || 'shippio',
            memo: attachment.memo || null
          }
        }
      });

      if (response) {
        this.$apollo.queries.attachments.refetch();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
        // reset edit fields
        this.renameInput.fileName = null;
        this.requestInput = {
          tag: null,
          dueDate: null,
          responsibleParty: 'shippio',
          memo: null
        };
        this.editAttachmentId = null;
        this.isEditing = false;
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }
}
